import {
    SET_ONLINE_TEXT,
    SET_OFFLINE_TEXT,
    SET_VIP_TEXT,
    SET_UNKNOWN_TEXT,
    SET_STATUSTEXTS,
} from './constants'

const initialState = {
    online: '',
    offline: '',
    vip: '',
    unknown: '',
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_ONLINE_TEXT: {
            return {
                ...state,
                online: action.payload,
            }
        }

        case SET_OFFLINE_TEXT: {
            return {
                ...state,
                offline: action.payload,
            }
        }

        case SET_VIP_TEXT: {
            return {
                ...state,
                vip: action.payload,
            }
        }

        case SET_UNKNOWN_TEXT: {
            return {
                ...state,
                unknown: action.payload,
            }
        }

        case SET_STATUSTEXTS: {
            return action.payload
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/ServerMenu/data/statusTexts/reducer.js